const baseJarUrl = 'https://send.monobank.ua/jar/';

export const jarUrlBuilder = (shortId: string, tag = true): string => {
  return `${baseJarUrl}${shortId}${tag ? '?t=zbir.net' : ''}`;
};
